import { memo } from "react";
import { Icon } from "@/components/icons/Icon";

export interface PhasePillProps {
  phaseName: string;
}

const PhasePill = ({ phaseName = "" }: PhasePillProps) => {
  return (
    <div className="h-6 w-fit px-2 flex flex-row gap-0.5 bg-ib-blue rounded-[16px] items-center">
      <Icon name="rotateArrows" className="size-4 text-ib-black" />
      <span className="text-[12px] leading-[100%]">{phaseName}</span>
    </div>
  );
};

export default memo(PhasePill);
